import React from 'react'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import MediaListItem from './MediaListItem'
import { EventMedia } from '../../types'

interface IProps {
  mediaData?: EventMedia[]
  filtered?: boolean
  selected?: EventMedia
  setSelected: (item: any, thumbnail: string | undefined) => void
  elementSize: number
  useRoundImageBorders?: boolean
}

const MediaList: React.FC<IProps> = ({ setSelected, selected, mediaData, elementSize, useRoundImageBorders }) => {
  const useStyles = makeStyles((theme: Theme) => ({
    uList: {
      display: 'flex',
      flexWrap: 'wrap',
      listStyleType: 'none',
      margin: 0,
      padding: 0,
    },
    roundBorder: {
      borderRadius: '50%',
    },
  }))

  const classes = useStyles()

  const handleClick = (item: EventMedia, thumbnail: string | undefined) => {
    return selected && item.id === selected.id ? setSelected({}, undefined) : setSelected(item, thumbnail)
  }

  return (
    <>
      <ul className={classes.uList}>
        {mediaData && mediaData.map((item: EventMedia, index: number) => {
          return (
            <li key={index} className={useRoundImageBorders ? classes.roundBorder : undefined}>
              <MediaListItem
                handleClick={handleClick}
                item={item}
                selected={selected}
                width={elementSize}
              />
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default MediaList
